/* Web Push subscription helpers — register service worker and subscribe the
   browser to push notifications via VAPID. Best-effort; silently no-ops on
   browsers that don't support Service Worker / Push API (older iOS).
*/

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export const isPushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export async function registerServiceWorker() {
  if (!isPushSupported()) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js');
  } catch (e) {
    console.warn('SW registration failed', e);
    return null;
  }
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush(API) {
  if (!isPushSupported()) return { ok: false, reason: 'unsupported' };
  if (Notification.permission === 'denied') return { ok: false, reason: 'denied' };
  const reg = await navigator.serviceWorker.ready;
  // Ask permission if not granted yet
  if (Notification.permission !== 'granted') {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return { ok: false, reason: 'denied' };
  }
  // Fetch VAPID public key
  const { data } = await API.get('/push/vapid-public-key');
  if (!data || !data.public_key) return { ok: false, reason: 'no_vapid_key' };
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await API.post('/push/subscribe', {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return { ok: true, subscription: sub };
}

export async function unsubscribeFromPush(API) {
  if (!isPushSupported()) return { ok: false };
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return { ok: true };
  const json = sub.toJSON();
  try {
    await API.post('/push/unsubscribe', { endpoint: json.endpoint, keys: json.keys });
  } catch (_) { /* ignore */ }
  await sub.unsubscribe();
  return { ok: true };
}
